import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: 'flex',
        justifyContent: "center",
        alignItems: "center",
        padding: '1rem',
    },
}));

export default useStyles;
